// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Role$ReactHooksTemplate = require("../settings/role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var EmailFromId$ReactHooksTemplate = require("../surveys/emailFromId.res.js");
var EmailContent$ReactHooksTemplate = require("./emailContent.res.js");
var ConditionForm$ReactHooksTemplate = require("../surveys/ConditionForm.res.js");
var NotificationRule$ReactHooksTemplate = require("./notificationRule.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");

function RuleModal(props) {
  var onSubmit = props.onSubmit;
  var updateLogicCondition = props.updateLogicCondition;
  var deleteCondition = props.deleteCondition;
  var addCondition = props.addCondition;
  var onCcDataFieldChange = props.onCcDataFieldChange;
  var onToDataFieldChange = props.onToDataFieldChange;
  var handleChange = props.handleChange;
  var isFormValid = props.isFormValid;
  var lhsOptions = props.lhsOptions;
  var onOpenAddEmail = props.onOpenAddEmail;
  var dataFields = props.dataFields;
  var fromIds = props.fromIds;
  var selectedRule = props.selectedRule;
  var isTicketGeneratedTrigger = NotificationRule$ReactHooksTemplate.triggerAction(selectedRule) === "ticket_generated";
  var isSurveyCreatedTrigger = NotificationRule$ReactHooksTemplate.triggerAction(selectedRule) === "survey_created";
  var supportsDataFieldRecipients = isTicketGeneratedTrigger || isSurveyCreatedTrigger;
  var inputBase = "w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150";
  var labelBase = "block text-sm font-medium text-gray-700 mb-1.5";
  var requiredMark = JsxRuntime.jsx("span", {
        children: "(required)",
        className: "text-red-500 font-normal ml-1"
      });
  var optionalMark = JsxRuntime.jsx("span", {
        children: "(optional)",
        className: "text-gray-500 font-normal ml-1"
      });
  var selectClass = "w-full min-h-[40px] flex items-center border border-gray-300 rounded-lg px-4 py-2 text-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500";
  var toFieldHint = isTicketGeneratedTrigger ? "Optional when a To data field is selected. Leave empty to email the ticket assignee only." : (
      isSurveyCreatedTrigger ? "Optional when a To data field is selected. Add static addresses or use a data field below." : "Select one or more recipient addresses."
    );
  var roleFieldHint = isTicketGeneratedTrigger ? "Optional. Role emails are added to To. Assignee is used if To, roles, and data field are empty." : (
      isSurveyCreatedTrigger ? "Optional. Role emails are added to To." : "Emails of users in the selected roles are added to To."
    );
  var dataFieldToHint = isTicketGeneratedTrigger ? "Optional. Email from this data field is added to To when the ticket notification is sent." : "Optional. Email from this data field is added to To when the survey notification is sent.";
  var dataFieldCcHint = isTicketGeneratedTrigger ? "Optional. Email from this data field is added to CC when the ticket notification is sent." : "Optional. Email from this data field is added to CC when the survey notification is sent.";
  var id = NotificationRule$ReactHooksTemplate.toDataFieldId(selectedRule);
  var selectedToDataFieldValue = id !== undefined ? String(id) : "";
  var id$1 = NotificationRule$ReactHooksTemplate.ccDataFieldId(selectedRule);
  var selectedCcDataFieldValue = id$1 !== undefined ? String(id$1) : "";
  var recipientField = function (label, hint, error, children) {
    return JsxRuntime.jsxs("div", {
                children: [
                  label,
                  children,
                  error !== undefined ? JsxRuntime.jsx("p", {
                          children: error,
                          className: "text-xs text-red-600 leading-snug mt-1.5"
                        }) : (
                      hint !== undefined ? JsxRuntime.jsx("p", {
                              children: hint,
                              className: "text-xs text-gray-500 leading-snug mt-1.5"
                            }) : null
                    )
                ],
                className: "flex flex-col"
              });
  };
  if (!props.show) {
    return null;
  }
  var lst = NotificationRule$ReactHooksTemplate.toAddress(selectedRule);
  var lst$1 = NotificationRule$ReactHooksTemplate.recipientRoleNames(selectedRule);
  var lst$2 = NotificationRule$ReactHooksTemplate.ccAddress(selectedRule);
  var lst$3 = NotificationRule$ReactHooksTemplate.bccAddress(selectedRule);
  var tmp;
  switch (props.formAction) {
    case "create" :
        tmp = "Create rule";
        break;
    case "update" :
        tmp = "Save changes";
        break;
    default:
      tmp = "Save";
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("h2", {
                                    children: selectedRule.name.length > 0 ? "Edit notification rule" : "Create notification rule",
                                    className: "text-lg font-bold text-gray-900"
                                  }),
                              JsxRuntime.jsx("img", {
                                    className: "h-14-px float-right cursor-pointer",
                                    alt: "Close",
                                    src: Image$ReactHooksTemplate.closeIcon,
                                    onClick: (function (param) {
                                        Curry._2(handleChange, undefined, "close");
                                      })
                                  })
                            ],
                            className: "flex-none shrink-0 p-8 mb-50-px flex text-lg font-bold justify-between items-center bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border-b border-gray-200 px-6 py-6"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "Basic information",
                                                  className: "text-xs font-bold text-blue-700 uppercase tracking-wider mb-4"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "Rule name",
                                                                    requiredMark
                                                                  ],
                                                                  className: labelBase,
                                                                  htmlFor: "rule-name"
                                                                }),
                                                            JsxRuntime.jsx("input", {
                                                                  className: inputBase,
                                                                  id: "rule-name",
                                                                  placeholder: "e.g. Notify on new ticket",
                                                                  value: selectedRule.name,
                                                                  onChange: (function (e) {
                                                                      Curry._2(handleChange, e, "name");
                                                                    })
                                                                })
                                                          ]
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsxs("label", {
                                                                  children: [
                                                                    "Send email when",
                                                                    requiredMark
                                                                  ],
                                                                  className: labelBase,
                                                                  htmlFor: "trigger"
                                                                }),
                                                            JsxRuntime.jsxs("select", {
                                                                  children: [
                                                                    JsxRuntime.jsx("option", {
                                                                          children: "Select an event...",
                                                                          value: ""
                                                                        }),
                                                                    $$Array.of_list(Belt_List.map({
                                                                              hd: [
                                                                                "ticket_generated",
                                                                                "When a ticket is generated"
                                                                              ],
                                                                              tl: {
                                                                                hd: [
                                                                                  "survey_created",
                                                                                  "When a survey is created"
                                                                                ],
                                                                                tl: {
                                                                                  hd: [
                                                                                    "user_created",
                                                                                    "When a user is created"
                                                                                  ],
                                                                                  tl: {
                                                                                    hd: [
                                                                                      "report_generated",
                                                                                      "Report created"
                                                                                    ],
                                                                                    tl: /* [] */0
                                                                                  }
                                                                                }
                                                                              }
                                                                            }, (function (param) {
                                                                                var value = param[0];
                                                                                return JsxRuntime.jsx("option", {
                                                                                            children: param[1],
                                                                                            value: value
                                                                                          }, value);
                                                                              })))
                                                                  ],
                                                                  className: inputBase + " cursor-pointer",
                                                                  id: "trigger",
                                                                  value: NotificationRule$ReactHooksTemplate.triggerAction(selectedRule),
                                                                  onChange: (function (e) {
                                                                      Curry._2(handleChange, e, "triggerAction");
                                                                    })
                                                                })
                                                          ]
                                                        })
                                                  ],
                                                  className: "grid grid-cols-1 sm:grid-cols-2 gap-5"
                                                })
                                          ],
                                          className: "pl-4 border-l-4 border-blue-500 rounded"
                                        }),
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("h3", {
                                                          children: "Email recipients",
                                                          className: "text-xs font-bold text-indigo-700 uppercase tracking-wider"
                                                        }),
                                                    JsxRuntime.jsx("button", {
                                                          children: "+ Add sender email",
                                                          className: "text-xs font-semibold text-indigo-600 hover:text-indigo-800 hover:bg-indigo-100 px-3 py-2 rounded-lg transition-colors duration-200",
                                                          type: "button",
                                                          onClick: (function (param) {
                                                              Curry._1(onOpenAddEmail, undefined);
                                                            })
                                                        })
                                                  ],
                                                  className: "flex items-center justify-between mb-4"
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Choose from your configured sender addresses.",
                                                  className: "text-sm text-gray-600 mb-4"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    recipientField(JsxRuntime.jsxs("label", {
                                                              children: [
                                                                "From",
                                                                requiredMark
                                                              ],
                                                              className: labelBase
                                                            }), undefined, undefined, JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                              options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                              placeholder: "Select sender",
                                                              handleChange: props.onFromAddressSelect,
                                                              selectedOptions: {
                                                                hd: NotificationRule$ReactHooksTemplate.fromAdress(selectedRule),
                                                                tl: /* [] */0
                                                              },
                                                              className: selectClass
                                                            })),
                                                    recipientField(JsxRuntime.jsxs("label", {
                                                              children: [
                                                                "To",
                                                                isTicketGeneratedTrigger || isSurveyCreatedTrigger ? optionalMark : requiredMark
                                                              ],
                                                              className: labelBase
                                                            }), toFieldHint, undefined, JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                              options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                              placeholder: isTicketGeneratedTrigger ? "Optional — assignee if empty" : (
                                                                  isSurveyCreatedTrigger ? "Optional — data field or roles" : "Select recipients"
                                                                ),
                                                              handleChange: props.onToAddressToggle,
                                                              selectedOptions: lst !== undefined ? lst : /* [] */0,
                                                              className: selectClass
                                                            })),
                                                    supportsDataFieldRecipients ? recipientField(JsxRuntime.jsxs("label", {
                                                                children: [
                                                                  "To from data field",
                                                                  optionalMark
                                                                ],
                                                                className: labelBase,
                                                                htmlFor: "to-data-field"
                                                              }), dataFieldToHint, props.toDataFieldError, JsxRuntime.jsxs("select", {
                                                                children: [
                                                                  JsxRuntime.jsx("option", {
                                                                        children: "None",
                                                                        value: ""
                                                                      }),
                                                                  $$Array.of_list(Belt_List.map(dataFields, (function (df) {
                                                                              var id = Belt_Option.getWithDefault(DataField$ReactHooksTemplate.id(df), 0);
                                                                              var label = DataField$ReactHooksTemplate.name(df);
                                                                              return JsxRuntime.jsx("option", {
                                                                                          children: label,
                                                                                          value: String(id)
                                                                                        }, String(id));
                                                                            })))
                                                                ],
                                                                className: inputBase + " cursor-pointer",
                                                                id: "to-data-field",
                                                                value: selectedToDataFieldValue,
                                                                onChange: (function (e) {
                                                                    Curry._1(onToDataFieldChange, e.target.value);
                                                                  })
                                                              })) : null,
                                                    JsxRuntime.jsx("div", {
                                                          children: recipientField(JsxRuntime.jsxs("label", {
                                                                    children: [
                                                                      "Add recipients by role",
                                                                      optionalMark
                                                                    ],
                                                                    className: labelBase
                                                                  }), roleFieldHint, undefined, JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                                    options: List.map(Role$ReactHooksTemplate.name, props.roles),
                                                                    placeholder: "Select roles",
                                                                    handleChange: props.onRecipientRoleToggle,
                                                                    selectedOptions: lst$1 !== undefined ? lst$1 : /* [] */0,
                                                                    className: selectClass
                                                                  })),
                                                          className: "sm:col-span-2"
                                                        }),
                                                    recipientField(JsxRuntime.jsxs("label", {
                                                              children: [
                                                                "CC",
                                                                optionalMark
                                                              ],
                                                              className: labelBase
                                                            }), "Optional. Additional addresses receive a copy of the email.", undefined, JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                              options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                              placeholder: "Select CC",
                                                              handleChange: props.onCcAddressToggle,
                                                              selectedOptions: lst$2 !== undefined ? lst$2 : /* [] */0,
                                                              className: selectClass
                                                            })),
                                                    supportsDataFieldRecipients ? recipientField(JsxRuntime.jsxs("label", {
                                                                children: [
                                                                  "CC from data field",
                                                                  optionalMark
                                                                ],
                                                                className: labelBase,
                                                                htmlFor: "cc-data-field"
                                                              }), dataFieldCcHint, props.ccDataFieldError, JsxRuntime.jsxs("select", {
                                                                children: [
                                                                  JsxRuntime.jsx("option", {
                                                                        children: "None",
                                                                        value: ""
                                                                      }),
                                                                  $$Array.of_list(Belt_List.map(dataFields, (function (df) {
                                                                              var id = Belt_Option.getWithDefault(DataField$ReactHooksTemplate.id(df), 0);
                                                                              var label = DataField$ReactHooksTemplate.name(df);
                                                                              return JsxRuntime.jsx("option", {
                                                                                          children: label,
                                                                                          value: String(id)
                                                                                        }, String(id));
                                                                            })))
                                                                ],
                                                                className: inputBase + " cursor-pointer",
                                                                id: "cc-data-field",
                                                                value: selectedCcDataFieldValue,
                                                                onChange: (function (e) {
                                                                    Curry._1(onCcDataFieldChange, e.target.value);
                                                                  })
                                                              })) : null,
                                                    recipientField(JsxRuntime.jsxs("label", {
                                                              children: [
                                                                "BCC",
                                                                optionalMark
                                                              ],
                                                              className: labelBase
                                                            }), undefined, undefined, JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                              options: List.map(EmailFromId$ReactHooksTemplate.fromId, fromIds),
                                                              placeholder: "Select BCC",
                                                              handleChange: props.onBccAddressToggle,
                                                              selectedOptions: lst$3 !== undefined ? lst$3 : /* [] */0,
                                                              className: selectClass
                                                            }))
                                                  ],
                                                  className: "grid grid-cols-1 sm:grid-cols-2 gap-5"
                                                })
                                          ],
                                          className: "pl-4 border-l-4 border-indigo-500 rounded"
                                        }),
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "When to send (conditions)",
                                                  className: "text-sm font-medium text-gray-600 mb-1"
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Email is sent only when all conditions below are met. Conditions are optional.",
                                                  className: "text-sm text-gray-600 mb-4"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: Belt_List.length(selectedRule.conditions) > 0 ? $$Array.of_list(Belt_List.mapWithIndex(selectedRule.conditions, (function (index, condition) {
                                                                return JsxRuntime.jsxs("div", {
                                                                            children: [
                                                                              JsxRuntime.jsx("div", {
                                                                                    children: JsxRuntime.jsx(ConditionForm$ReactHooksTemplate.make, {
                                                                                          lhsOptions: lhsOptions,
                                                                                          condition: condition,
                                                                                          updateLogicCondition: (function (updatedCondition) {
                                                                                              Curry._2(updateLogicCondition, updatedCondition, index);
                                                                                            })
                                                                                        }),
                                                                                    className: "flex-1 min-w-0"
                                                                                  }),
                                                                              JsxRuntime.jsxs("div", {
                                                                                    children: [
                                                                                      JsxRuntime.jsx("div", {
                                                                                            children: JsxRuntime.jsx("img", {
                                                                                                  className: "h-5 w-5",
                                                                                                  alt: "Add",
                                                                                                  src: Image$ReactHooksTemplate.plusCircle
                                                                                                }),
                                                                                            className: "cursor-pointer",
                                                                                            onClick: (function (param) {
                                                                                                Curry._1(addCondition, undefined);
                                                                                              })
                                                                                          }),
                                                                                      JsxRuntime.jsx("div", {
                                                                                            children: JsxRuntime.jsx("img", {
                                                                                                  className: "h-5 w-5",
                                                                                                  alt: "Remove",
                                                                                                  src: Image$ReactHooksTemplate.trashGrey
                                                                                                }),
                                                                                            className: "cursor-pointer",
                                                                                            onClick: (function (param) {
                                                                                                Curry._1(deleteCondition, index);
                                                                                              })
                                                                                          })
                                                                                    ],
                                                                                    className: "flex gap-2 items-center pt-22-px"
                                                                                  })
                                                                            ],
                                                                            className: "flex justify-between items-start w-full gap-4"
                                                                          }, String(index));
                                                              }))) : JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("span", {
                                                                  children: "No conditions. Email is sent on every trigger."
                                                                }),
                                                            JsxRuntime.jsxs("button", {
                                                                  children: [
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "h-4 w-4",
                                                                          alt: "Add",
                                                                          src: Image$ReactHooksTemplate.plusCircle
                                                                        }),
                                                                    "Add condition"
                                                                  ],
                                                                  className: "inline-flex items-center gap-1.5 text-indigo-600 hover:text-indigo-800 font-medium",
                                                                  type: "button",
                                                                  onClick: (function (param) {
                                                                      Curry._1(addCondition, undefined);
                                                                    })
                                                                })
                                                          ],
                                                          className: "flex items-center gap-2 text-sm text-gray-500 py-2"
                                                        }),
                                                  className: "space-y-4"
                                                })
                                          ],
                                          className: "bg-gradient-to-r from-gray-50 to-blue-50 rounded-lg p-7 border border-gray-200"
                                        }),
                                    JsxRuntime.jsxs("section", {
                                          children: [
                                            JsxRuntime.jsx("h3", {
                                                  children: "Email template",
                                                  className: "text-sm font-medium text-gray-600 mb-4"
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsxs("label", {
                                                          children: [
                                                            "Content template",
                                                            requiredMark
                                                          ],
                                                          className: labelBase,
                                                          htmlFor: "email-content"
                                                        }),
                                                    JsxRuntime.jsxs("select", {
                                                          children: [
                                                            JsxRuntime.jsx("option", {
                                                                  children: "Select template...",
                                                                  value: ""
                                                                }),
                                                            $$Array.of_list(Belt_List.map(props.emailContentInfos, (function (info) {
                                                                        var name = EmailContent$ReactHooksTemplate.name(info);
                                                                        return JsxRuntime.jsx("option", {
                                                                                    children: info.name,
                                                                                    value: name
                                                                                  }, name);
                                                                      })))
                                                          ],
                                                          className: inputBase + " cursor-pointer",
                                                          id: "email-content",
                                                          value: EmailContent$ReactHooksTemplate.name(selectedRule.emailContent),
                                                          onChange: (function (e) {
                                                              Curry._2(handleChange, e, "emailContent");
                                                            })
                                                        })
                                                  ]
                                                })
                                          ],
                                          className: "pl-4 border-l-4 border-amber-500 rounded"
                                        })
                                  ],
                                  className: "px-6 py-6 space-y-8 pb-4"
                                }),
                            className: "flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Cancel",
                                    className: "px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 mr-3",
                                    type: "button",
                                    onClick: (function (param) {
                                        Curry._2(handleChange, undefined, "close");
                                      })
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: tmp,
                                    className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                      isFormValid ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
                                    ),
                                    disabled: !isFormValid,
                                    type: "button",
                                    onClick: (function (param) {
                                        if (isFormValid) {
                                          return Curry._1(onSubmit, selectedRule);
                                        }
                                        
                                      })
                                  })
                            ],
                            className: "flex-none shrink-0 flex justify-end mt-4 p-8 border-t border-gray-200"
                          })
                    ],
                    className: "bg-white modal-data-fields z-10 shadow relative border border-gray-300 pointer-events-auto rounded-xl overflow-hidden flex flex-col",
                    style: {
                      height: "calc(100vh - 2rem)",
                      maxHeight: "calc(100vh - 2rem)",
                      minHeight: "20rem"
                    },
                    onClick: (function (e) {
                        e.stopPropagation();
                      })
                  }),
              className: "w-screen z-50 disabled-wrapper fixed inset-0 flex justify-center items-center overflow-hidden",
              style: {
                height: "calc(100vh + 5rem)"
              },
              onClick: (function (param) {
                  Curry._2(handleChange, undefined, "close");
                })
            });
}

var make = RuleModal;

exports.make = make;
/* react/jsx-runtime Not a pure module */
